import {
	AfterContentInit,
	ContentChildren,
	DestroyRef,
	Directive,
	Input,
	output,
	QueryList,
} from '@angular/core'
import { MatTabGroup } from '@angular/material/tabs'
import { TabGroupTabControlDirective } from './tab-group-tab-control-directive.js'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Directive({
	selector: 'mat-tab-group',
	exportAs: 'lowgileTabGroupControl',
	standalone: false,
})
export class TabGroupControlDirective implements AfterContentInit {
	lowgileSelectedTabChange = output<string>()

	afterContentInitCallback?: () => void
	@ContentChildren(TabGroupTabControlDirective)
	tabs!: QueryList<TabGroupTabControlDirective>
	constructor(
		private matTabGroup: MatTabGroup,
		destroyRef: DestroyRef,
	) {
		matTabGroup.selectedTabChange
			.pipe(takeUntilDestroyed(destroyRef))
			.subscribe((event) => {
				const tabIdx = event.index
				if (tabIdx < 0) return
				const tabName = this.getTabNameFromIndex(tabIdx)
				this.lowgileSelectedTabChange.emit(tabName)
			})
	}

	@Input()
	set lowgileSelectedTab(nameOrIdx: string | number) {
		if (nameOrIdx == undefined) return

		if (typeof nameOrIdx == 'string') {
			if (!this.tabs) {
				// this.tabs not available before ngAfterCodeInit, therefore set it later
				this.afterContentInitCallback = () =>
					(this.lowgileSelectedTab = nameOrIdx)
				return
			}
			const tabIdx = [...this.tabs].findIndex(
				(tab) => tab.getTabName() == nameOrIdx,
			)
			if (tabIdx >= 0) {
				this.matTabGroup.selectedIndex = tabIdx
			}
		} else {
			this.matTabGroup.selectedIndex = nameOrIdx
		}
	}

	ngAfterContentInit(): void {
		this.afterContentInitCallback?.()
		this.afterContentInitCallback = undefined
	}

	getTabNameFromIndex(tabIdx: number) {
		const tab = [...this.tabs][tabIdx]
		return tab?.getTabName()
	}
}
